.DateTile {
    --DateTile--size: 44px;
    --DateTile--day--font-size: var(--soniq-t--global--font--size--amount);
    --DateTile--top-line--font-size: 9px;

    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1px;
    flex-shrink: 0;
    box-sizing: border-box;
    width: var(--DateTile--size);
    height: var(--DateTile--size);
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    border-radius: var(--soniq-t--global--border--radius--primary--md);
    background: var(--soniq-t--global--background--color--primary--default);
    font-family: var(--soniq-t--global--font--family--sans);
    line-height: 1;

    &.isSizeSmall {
        --DateTile--size: 36px;
        --DateTile--day--font-size: 13px;
    }

    &.isSizeLarge {
        --DateTile--size: 56px;
        --DateTile--day--font-size: 20px;
        --DateTile--top-line--font-size: var(--soniq-t--global--font--size--field-label);
        gap: 2px;
    }

    &.isHighlighted {
        border-color: var(--soniq-t--global--palette--hot-pink);
        /* Mixed with the page background so the fill stays opaque
           on any row surface */
        background: color-mix(
                in srgb,
                var(--soniq-t--global--palette--hot-pink) 6%,
                var(--soniq-t--global--background--color--primary--default)
        );
    }

    &.isPast {
        opacity: 0.5;
    }
}

.DateTile__topLine {
    font-size: var(--DateTile--top-line--font-size);
    font-weight: var(--soniq-t--global--font--weight--medium);
    letter-spacing: 0.08em;
    /* Balance the trailing letter spacing so the text stays centred */
    margin-right: -0.08em;
    text-transform: uppercase;
    color: var(--soniq-t--global--text--color--label--default);
}

.DateTile__day {
    font-size: var(--DateTile--day--font-size);
    font-weight: var(--soniq-t--global--font--weight--semibold);
    color: var(--soniq-t--global--text--color--primary--default);
}

/* The full date, read by screen readers only */
.DateTile__label {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
}
